import EachSymbolShape, {
  symbolShapePropTypes,
  symbolShapeBaseDefaults,
} from "./EachSymbolShape";

// Star shape definition (from ChartIQ) — config sobre EachSymbolShape
const STAR_DIMENSION = [12, 12];

// Star path centered at origin
// Original ChartIQ path: M 0,4 L 4,4 L 5.5,0 L 7,4 L 11,4 L 8,7 L 9,11 L 5.5,9 L 2,11 L 3,7 L 0,4
const getStarPath = ([w, h]) => {
  const cx = (w - 1) / 2; // 5.5
  const cy = (h - 1) / 2; // 5.5
  return `M ${0 - cx},${4 - cy} L ${4 - cx},${4 - cy} L ${5.5 - cx},${0 - cy} L ${7 - cx},${4 - cy} L ${11 - cx},${4 - cy} L ${8 - cx},${7 - cy} L ${9 - cx},${11 - cy} L ${5.5 - cx},${9 - cy} L ${2 - cx},${11 - cy} L ${3 - cx},${7 - cy} Z`;
};

class EachStar extends EachSymbolShape {}

EachStar.propTypes = symbolShapePropTypes;

EachStar.defaultProps = {
  ...symbolShapeBaseDefaults,
  dimension: STAR_DIMENSION,
  getPath: getStarPath,
  stroke: { color: "#FFD700", width: 2, opacity: 1, dash: "Solid" },
  fill: { color: "#FFD700", opacity: 0.6 },
};

export default EachStar;
